import { Pagination, User, Sort } from '@shared/data';
import { CbDataTableOptions, CbDataTableColumnType } from './../../cb-data-table';

export class UserListDataTableOptions implements CbDataTableOptions<User> {
  sort = new Sort();
  pagination;
  noResult = "common.noResult";
  header = true;
  columns = [
    {
      type: CbDataTableColumnType.TEXT,
      sortKey: null,
      label: 'user.fullName',
      value: (o: User) => {
        return o.fullName;
      }
    },
    {
      type: CbDataTableColumnType.TEXT,
      sortKey: null,
      label: 'user.email',
      value: (o: User) => {
        return o.email;
      }
    },
    {
      type: CbDataTableColumnType.TEXT,
      sortKey: null,
      label: 'user.role',
      value: (o: User) => {
        return o['role'];
      }
    }
  ];

  editable(o): boolean {
    return false;
  };

  deletable(o: User): boolean {
    return o.id != User.current().id;
  };
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+user/user-list/user-list.data-table-options.ts